(function () {
  // carousel-only (extracted from product_block.js slides.js)
  window.shopify = window.shopify || {};
  const uniqueClassRegex = new RegExp("^i[a-zA-Z0-9]{16}(-[a-zA-Z0-9]{16})*$");
  const isUniqueClass = (cls) => uniqueClassRegex.test(cls);
  const getPrimaryClass = (el) => {
    const classes = Array.from(el.classList || []);
    return classes.find((c) => isUniqueClass(c)) || classes[0] || "";
  };
  window.shopify.initializedSwiper = !!window.shopify?.initializedSwiper;
  window.shopify.initSwiper =
    window.shopify?.initSwiper ||
    (() => {
      if (!window.shopify.initializedSwiper) {
        window.shopify.initializedSwiper = true;
        if (window.shopify.initializedListeners && window.__shopifyInitSliders) {
          window.__shopifyInitSliders();
        }
      }
    });
  function initshopifySliders(root) {
    const scope = root || document;
    if (!window.shopify.initializedSwiper) {
      if (scope.querySelector('[data-shopify-type="slider"]')) {
        // const script = document.createElement("script");
        // script.onload = window.shopify.initSwiper;
        // script.src = window.shopify.swiperScriptUrl || "scripts/swiper-bundle.min.js";
        // document.body.appendChild(script);
        const tryLoad = (urls, idx = 0) => {
          if (!urls || idx >= urls.length) return;
          const script = document.createElement("script");
          script.onload = window.shopify.initSwiper;
          script.onerror = () => tryLoad(urls, idx + 1);
          script.src = urls[idx];
          document.body.appendChild(script);
        };
        const urls = [];
        if (window.shopify.swiperScriptUrl) urls.push(window.shopify.swiperScriptUrl);
        urls.push("scripts/swiper-bundle.min.js");
        urls.push("https://cdn.jsdelivr.net/npm/swiper@9/swiper-bundle.min.js");
        tryLoad(urls, 0);
      }
      return;
    }
    const thumbnailById = {};
    const mount = (container, kind = "slider") => {
      if (!container || !container.id) return;
      const paramsNode = document.getElementById(`shopify-slider-${container.id}-params`);
      const sectionId = container.closest(".__shopify")?.getAttribute("data-section-id");
      const sliderId = container.getAttribute("data-shopify-slider-id");
      try {
        if (!paramsNode || !paramsNode.innerHTML) return;
        const config = JSON.parse(paramsNode.innerHTML);
        if (sectionId && config.navigation) {
          config.navigation.nextEl = `[data-section-id='${sectionId}'] ${config.navigation.nextEl}`;
          config.navigation.prevEl = `[data-section-id='${sectionId}'] ${config.navigation.prevEl}`;
        }
        if (config.pagination) {
          const scopedSelector = `[data-section-id='${sectionId}'] ${config.pagination.el}`;
          config.pagination.el = scopedSelector;
          const pagEl = document.querySelector(scopedSelector);
          const bullet = pagEl?.querySelector(".shopify-slider-pagination-bullet");
          if (pagEl && bullet) {
            const bulletIdClass = getPrimaryClass(bullet);
            config.pagination.renderBullet = (index, className) =>
              `<span class="${className} ${bulletIdClass}"></span>`;
          }
        }
        config.on = config.on || {};
        config.on.changeDirection = (swiper) => {
          if (swiper.params.direction === "horizontal") {
            const wrapper = container.querySelector(":scope > .shopify-slider-wrapper");
            if (wrapper) wrapper.style.height = "";
          }
        };
        if (kind === "thumbnails") {
          const thumbsSwiper = new Swiper(container, config);
          thumbnailById[`${sliderId}`] = thumbsSwiper;
        } else {
          if (config.thumbs && thumbnailById?.[`${sliderId}`]) {
            config.thumbs = { swiper: thumbnailById[`${sliderId}`], ...config.thumbs };
          }
          new Swiper(container, config);
        }
      } catch (err) {}
    };
    scope.querySelectorAll('[data-shopify-type="thumbnails"]').forEach((el) => mount(el, "thumbnails"));
    scope.querySelectorAll('[data-shopify-type="slider"]').forEach((el) => mount(el));
  }
  window.__shopifyInitSliders = function (root) {
    initshopifySliders(root || document);
  };
  function readySlides() {
    window.shopify.initializedListeners = true;
    if (window.__shopifyInitSliders) {
      window.__shopifyInitSliders();
    }
  }
  if (document.readyState !== "loading") readySlides();
  else document.addEventListener("DOMContentLoaded", readySlides);
})();


